import { useEffect, useState } from 'react';

import { useTheme } from 'styled-components';

import { Tooltip as ToolTipUI } from '@develop-fapp/ui-kit-fapp';
import { TooltipProps as TooltipPropsUi } from '@develop-fapp/ui-kit-fapp/dist/types';

type TooltipProps = TooltipPropsUi & {
  validateChange?: boolean;
};

const Tooltip: React.FC<TooltipProps> = ({
  noShownOnHover = true,
  active = false,
  validateChange = false,
  content,
  direction,
  horizontalAlign,
  verticalAlign,
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const [isToolTipActive, setIsToolTipActive] = useState(active);
  const [isTooltipHidden, setIsTooltipHidden] = useState(true);

  const { colors } = useTheme();

  const hideTooltip = () => {
    setIsToolTipActive(false);
    setIsTooltipHidden(true);
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    if (!validateChange || isTooltipHidden) return;

    hideTooltip();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  useEffect(() => {
    setIsTooltipHidden(false);

    setTimeout(() => {
      hideTooltip();
    }, 6000);
  }, []);

  return isVisible ? (
    <ToolTipUI
      content={content}
      direction={direction}
      horizontalAlign={horizontalAlign}
      verticalAlign={verticalAlign}
      active={isToolTipActive}
      backgroundColor={isToolTipActive ? colors.yellow3 : undefined}
      noShownOnHover={noShownOnHover}
    >
      {children}
    </ToolTipUI>
  ) : (
    <div />
  );
};

export { Tooltip };
